import { useAuth0 } from '@auth0/auth0-react';
import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { resetUserPasswordAuth0 } from '../../../api/auth0Api';

function useResetUserPassword() {
  const { getAccessTokenSilently } = useAuth0();
  const queryClient = useQueryClient();
  const [resetPasswordPopover, setResetPasswordPopover] = useState(null);
  const [auth0UserId, setAuth0UserId] = useState('');

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const { mutate: handleResetPassword } = useMutation({
    mutationFn: async () => {
      handleCloseResetPasswordPopover();
      toast.loading('Reseteando contraseña...', {
        id: 'reseting-password',
      });
      let token = await getAccessTokenSilently();
      await resetUserPasswordAuth0(token, auth0UserId);
    },
    onSuccess: async () => {
      await sleep(1000);
      queryClient.invalidateQueries(['all-users']);
    },
    onError: (error) => {
      toast.error('Se ha producido un error al resetar la contraseña.');
      console.log('error', error);
    },
    onSettled: () => {
      toast.dismiss('reseting-password');
    },
  });

  const handleCloseResetPasswordPopover = () => {
    setResetPasswordPopover(null);
  };

  const handleClickResetPasswordPopover = (event) => {
    setAuth0UserId(event.currentTarget.dataset.userId);
    setResetPasswordPopover(event.currentTarget);
  };

  const handleConfirmResetPasswordPopover = (type) => {
    handleResetPassword();
  };

  return {
    resetPasswordPopover,
    handleCloseResetPasswordPopover,
    handleClickResetPasswordPopover,
    handleConfirmResetPasswordPopover,
  };
}

export default useResetUserPassword;
